/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

export type CountriesCoordinatesParams = {
  /**
   * Longitude coordinate
   * @minimum -180
   * @maximum 180
   */
  longitude: number;
  /**
   * Latitude coordinate
   * @minimum -90
   * @maximum 90
   */
  latitude: number;
};
